export const UploadEndpoints = {
    getFilesByEntityType(entityId, entityType) {
        return `${process.env.API_CLUB_CONTENT}/v4/files/entity/${entityId}/${entityType}`;
    },
    getUploadConfig() {
        return `${process.env.API_CLUB_FILE}/v4/upload/config`;
    }
};
